import React from 'react';
import { ISignUpManager } from 'views/public/SignUp/useSignUpManager';
import { NSInput } from 'bricks';
import { NSButtonBase } from 'bricks/NSButton/NSButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons';
import { STATIC_URLS, URLS } from 'services/urls';
import { PRO_FORMA_TABS } from 'views/ProFormaTable/constants';

export interface ISignUpSectionProps {
    setCurrentTab: (tabName: string) => void;
    setDisplayManualSignUp: (display: boolean) => void;
    signUpManager: ISignUpManager;
}

const SignUpSection = ({
    setCurrentTab, setDisplayManualSignUp, signUpManager,
}: ISignUpSectionProps) => {
    const {
        SSOSignUpEnabled,
        organizationName,
        isOrgNameValid,
        orgValidationSuccess,
        handleOrganizationNameChange,
        handleLinkedInSignUp,
    } = signUpManager;

    return (
        <div>
            <div className="text-center mb-1">
                <p className="text-white mb-0">Create an account to see full insights.</p>
                <small className="mt-0">
                    By creating an account, you agree to our
                    {' '}
                    <a
                        href={STATIC_URLS.TERMS_AND_CONDITIONS}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Terms and Conditions
                    </a>
                    {' '}
                    and
                    {' '}
                    <a
                        href={STATIC_URLS.PRIVACY_POLICY}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Privacy Policy.
                    </a>
                </small>
            </div>
            <NSInput
                id="organizationName"
                name="organizationName"
                type="text"
                placeholder="Organization name"
                value={organizationName.value}
                onChange={handleOrganizationNameChange}
                className="mx-2"
                autoComplete="organization"
                invalid={!isOrgNameValid}
            />
            <div className="mx-auto mt-1 px-2">
                <NSButtonBase
                    color="secondary"
                    callback={handleLinkedInSignUp}
                    className="DirectSignUp__LinkedIn"
                    innerContentClassName="DirectSignUp__LinkedIn__Content"
                    disabled={!SSOSignUpEnabled}
                    dataTestId="sideBarLinkedInButton"
                >
                    <span>
                        <img src={URLS.IMAGE_CLOUDFRONT_URL('socials/linkedin.png')} alt="LinkedIn" />
                        {' '}
                        Sign up with LinkedIn
                    </span>
                </NSButtonBase>
            </div>
            <div className="d-flex align-items-center px-2">
                <hr className="DirectSignUp__DividerLine" />
                <small className="DirectSignUp__DividerText">OR</small>
                <hr className="DirectSignUp__DividerLine" />
            </div>
            <div className="px-2">
                <NSButtonBase
                    color="primary"
                    callback={() => {
                        setCurrentTab(PRO_FORMA_TABS.DEVELOPMENT.name);
                        setDisplayManualSignUp(true);
                    }}
                    disabled={!orgValidationSuccess}
                    className="w-100"
                    dataTestId="sidebarCreateAccountButton"
                >
                    Create account with my email
                </NSButtonBase>
            </div>
            <div className="mt-1 text-white text-center">
                <small>
                    Already have an account?
                    {' '}
                    <a
                        href="/"
                        className="cursor-pointer"
                        rel="noopener noreferrer"
                    >
                        Sign in
                        <FontAwesomeIcon icon={faAngleRight} className="ml-1" />
                    </a>
                </small>
            </div>
        </div>
    );
};

export default SignUpSection;
